<template>
  <div>
    <v-icon>visibility</v-icon> {{ getPreview }}
  </div>
</template>

<script>
export default {
  props: {
    preview: {
      type: Number,
      default: 0
    }
  },
  computed: {
    getPreview() {
      return this.preview;
    }
  }
}
</script>
